<template>
	<CharacteristicEdit
		:value="value"
		title="Branche(n)"
		with-keyword
		:characteristic-type="meta.industrialSectorType"
		:characteristic-items="meta.industrialSector"
		label-type="job-profile"
		:selected-items-config="{
			showExperience: false
		}"
		:search-config="{ catalog: meta.searchCatalogIndustrialSector }"
		open-fan-button-alignment="left"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit";

export default {

	components: {
		CharacteristicEdit,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		help: {
			type: Object,
			required: false,
		},
	},
}
</script>
